import { Container,AppBar } from '@mui/material';
import {React,useEffect} from 'react'
import Footer from '../footer/Footer';
import { useParams } from "react-router-dom";
import Article from "./Article2.png"

// import BannerImg from './bannerimg/BannerImg'
// import TrendingTopics from './trendingtopics/TrendingTopics'
// import SearchBox from './searchbox/Searchbox'
// import GuideCards from './guidecards/GuideCards'
// import Tools from './tools/Tools'
// import VideoTutorial from './videotutorial/VideoTutorial'
// import YoutubePlayer from './youtubeplayer/YoutubeVideos'
// import YoutubeVideos from './youtubeplayer/YoutubeVideos'
//import InfoVideos from './videotutorial/InfoVideos'


const headingStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  color :'#221F1F',
  lineHeight: '36px',
};

const titleStyle = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: '32px',
  color:"#31B9B5",
  lineHeight: '53.25px',
}; 
const paragraphStyle = {
  fontFamily: 'DM Sans',
  fontWeight: 400,
  fontSize: '16px',
  color:'#222222BF',
  lineHeight: '40.73px',
  textAlign: 'justify',


};
 
const Heading = ({ level, text }) => {
  const HeadingComponent = `h${level}`;

  return <HeadingComponent style={headingStyle}>{text}</HeadingComponent>;
};

const Paragraph = ({ text }) => {
  return <p style={paragraphStyle}>{text}</p>;
};


const Title = ({ level, text }) => {
  const HeadingComponent = `h${level}`;

  return <HeadingComponent style={titleStyle}>{text}</HeadingComponent>;
};

const ArticlePage1 = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <Container maxWidth="xl" className="articleContainer">
   
     <div paddingLeft='25px'>

<img src={Article} alt="Article 2" style={{ maxWidth: '100%', height: 'auto', marginTop: '50px'}} />
      <Title level={1} text="Filling out the Application Form" />

      <Heading level={2} text="Guidelines for Effective Application Form Completion" />
      
      <Heading level={2} text="Read Instructions" />
      <Paragraph text="Begin by carefully reading through the instructions provided with the application form. Pay attention to any specific guidelines, requirements, or sections that need to be completed." />

      <Heading level={2} text="Personal Information" />
      <Paragraph text="Start by entering your personal information accurately. This typically includes your full name, contact information (phone number, email address, and home address), date of birth, and Social Security number." />

      <Heading level={2} text="Employment History" />
      <Paragraph text="Provide a detailed account of your employment history, starting with your most recent or current job. Include the name of the employer, your job title, dates of employment, and a description of your responsibilities and accomplishments in each role. If there are gaps in your employment history, be prepared to explain them." />

      <Heading level={2} text="Education"  />
      <Paragraph text="List your educational background , including the institutions you attended, the degrees or certifications you obtained, and the dates of graduation. Include any academic honors, awards, or relevant coursework." />

      <Heading level={2} text="Skills and Qualifications" />
      <Paragraph text="Highlight your skills, qualifications, and certifications that are relevant to the position or program you're applying for. This may include technical skills, language proficiency, software knowledge, or any other abilities that make you a strong candidate. Be concise and specific in describing your skills." />

      <Heading level={2} text="References" />
      <Paragraph text="If the application form requires references, provide the names, contact information, and professional relationships of individuals who can speak to your qualifications, character, and work ethic. Make sure to obtain their consent beforehand." />

      <Heading level={2} text="Personal Statement or Essay" />
      <Paragraph text="Some application forms may include a section for a personal statement or essay. Use this opportunity to showcase your personality, motivations, and why you are a good fit for the position or program. Tailor your statement to address the specific requirements and values outlined in the application." />

      <Heading level={2} text="Proofread" />
      <Paragraph text="Carefully review your completed application form before submitting it. Check for any spelling or grammatical errors, and ensure that all information is accurate and up to date. It can be helpful to have someone else review it as well to catch any mistakes you may have missed." />

      <Heading level={2} text="Attach Supporting Documents" />
      <Paragraph text="If required, gather and attach any supporting documents, such as resumes, cover letters, transcripts, or certificates. Make sure to follow the instructions provided on the application form regarding document submission." />

      <Heading level={2} text="Keep a Copy" />
      <Paragraph text="Make a copy of the completed application form for your records. This can be useful for future reference or if any discrepancies arise during the application process." />
    </div>
    </Container>
  );
};


export default ArticlePage1;

